<template>
  <div class="seller-detail">
    <div class="breadcrumbs">
      <breadcrumbs :breadcrumbsData="breadcrumbsData"/>
    </div>
    <a-spin :spinning="spinning">
      <div class="content-wrap">
        <div class="info-wrap">
          <div class="head">Payment Info</div>
          <div class="info">
            <div class="left">
              <div>
                <div class="text">
                  <span>Billing Date: </span>
                  <span v-if="detailData.marketplace">{{moment(detailData.billingDateTimestamp).tz(BILLING_TIME_TZ[detailData.marketplace]).format('YYYY-MM')}}</span>
                </div>
                <div class="text">
                  <span>Payment Amount: </span>
                  <span>{{AMAZON_CURRENCY_MAPPER[detailData.marketplace]}}{{detailData.amount}}</span>
                </div>
                <div class="text">
                  <span>Payment Status: </span>
                  <span>{{FINANCE_SELLER_STATUS_MAP[detailData.status]?.label}}</span>
                </div>
              </div>
              <div  v-if="detailData.status !== 'pending'">
                <div class="text">
                  <span>Pending: </span>
                  <span>{{AMAZON_CURRENCY_MAPPER[detailData.marketplace]}}{{detailData.pendingAmount}}</span>
                </div>
                <div class="text">
                  <span>Ready To Pay: </span>
                  <span>{{AMAZON_CURRENCY_MAPPER[detailData.marketplace]}}{{detailData.readyToPayAmount}}</span>
                </div>
                <div class="text">
                  <span>Paid: </span>
                  <span>{{AMAZON_CURRENCY_MAPPER[detailData.marketplace]}}{{detailData.paidAmount}}</span>
                </div>
                <div class="text">
                  <span>Not Applicable: </span>
                  <span>{{AMAZON_CURRENCY_MAPPER[detailData.marketplace]}}{{detailData.declinedAmount}}</span>
                </div>
              </div>
            </div>
            <artmisads-button v-if="detailData.status === 'pending'" @click="() => setShowConfirmModal(true)" type="primary" size="middle">Confirm</artmisads-button>
          </div>
        </div>
        <div class="details">
          <div class="head">
            <span>Details</span>
          </div>
          <div class="operation">
            <div class="left">
              <div class="item">
                <span>Publisher Name</span>
                <artmisads-select
                  show-search
                  v-model:value="params.publisherId"
                  style="width: 232px"
                  :options="sellerOptions"
                  @search="searchPublisher"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  placeholder="All"
                  allowClear
                  @change="onChangePublisher"
                />
              </div>
              <div class="item" v-if="detailData.status !== 'pending'">
                <span>Seller Status</span>
                <artmisads-select
                  style="width: 232px"
                  v-model:value="params.sellerPayStatus"
                  :filter-option="false"
                  :not-found-content="null"
                  :options="FINANCE_SELLER_PAYMENT_STATUS"
                  placeholder="All"
                />
              </div>
              <div class="item" v-if="detailData.status !== 'pending'">
                <span>Status</span>
                <artmisads-select
                  style="width: 232px"
                  v-model:value="params.detailStatus"
                  :filter-option="false"
                  :not-found-content="null"
                  :options="FINANCE_PAYMENT_PUBLISHER_DETAIL_STATUS"
                  placeholder="All"
                />
              </div>
              <div class="item">
                <span>PaymentID</span>
                <artmisads-input v-model:value="params.billingId" size="middle" />

              </div>
            </div>
            <div class="right">
               <artmisads-button @click="exportData" :isSquare="true" type="primary"
                size="middle">Export</artmisads-button>
              <artmisads-button
                @click="getFinancePublisherBillingsDetailsList"
                :isSquare="true"
                type="primary"
                size="middle"
                >Search</artmisads-button
              >
              <artmisads-button
                @click="() => setParams()"
                type="text"
                :isSquare="true"
                size="middle"
                >Reset</artmisads-button
              >
            </div>
          </div>
        </div>
        <div class="table">
          <sellerTable
            :params="params"
            :dataList="list"
            :setParams="setParams"
            :getList="getFinancePublisherBillingsDetailsList"
            :listTotal="listTotal"
            :status="detailData.status"
            :toDeclined="toDeclinedCallback"
            :toUnDoDeclined="toUnDoDeclinedCallback"
            :setBillingId="setBillingId"
            :setShowHistoryModal="setShowHistoryModal"
            :setShowPaymentModal="setShowPaymentModal"
            :setShowPaymentDetailModal="setShowPaymentDetailModal"
          />
        </div>
      </div>
    </a-spin>
    <paymentDetailModal
      :billingId="billingId"
      :setShowPaymentDetailModal="setShowPaymentDetailModal"
      :marketplace="detailData.marketplace"
      v-if="billingId && showPaymentDetailModal"
    />
    <paymentModal
      :showPaymentModal="showPaymentModal"
      :billingId="billingId"
      :setShowPaymentModal="setShowPaymentModal"
      v-if="billingId && showPaymentModal"
    />
    <historyModal
      :showHistoryModal="showHistoryModal"
      :billingId="billingId"
      :setShowHistoryModal="setShowHistoryModal"
      :marketplace="detailData.marketplace"
      v-if="showHistoryModal"
    />
    <artmisads-modal
      v-model:open="showConfirmModal"
      :width="500"
      title="Payment Confirm?"
      okText="Confirm"
      @ok="onChangeStatus"
    >
      <div class="active-product">
        <div class="title-ext">
          Are you sure to send payments to all publishers?
        </div>
      </div>
    </artmisads-modal>
  </div>
</template>
<script setup>
  import moment from 'moment';
  import { computed, onBeforeMount, onMounted, ref } from 'vue';
  import { financeApi } from "~/server/operator/finance";
  import { publisherAdminApi } from "~/server/index";
  import breadcrumbs from "../../../breadcrumbs.vue";
  import sellerTable from './sellerTable';
  import paymentModal from './paymentModal';
  import paymentDetailModal from './paymentDetailModal';
  import historyModal from './historyModal';
  import { useRoute } from 'vue-router';
  import { AMAZON_CURRENCY_MAPPER, BILLING_TIME_TZ } from '~/contants/common';
  import { FINANCE_PAYMENT_PUBLISHER_DETAIL_STATUS, FINANCE_SELLER_STATUS_MAP, FINANCE_SELLER_STATUS, FINANCE_SELLER_PAYMENT_STATUS } from '~/contants/operator';
  import { message } from 'ant-design-vue';

  const params = ref({
    id: '',
    publisherId: '',
    size: 10,
    page: 1,
    detailStatus: null,
    sellerPayStatus: null,
    billingId: null
  })
  const showPaymentDetailModal = ref(false);
  const showHistoryModal = ref(false);
  const billingId = ref('');
  const showPaymentModal = ref(false)
  const showConfirmModal = ref(false);
  const listTotal = ref(0);
  const list = ref([]);
  const route = useRoute();
  const sellerOptions = ref([]);
  const spinning = ref(true);
  const detailData = ref({});
  const breadcrumbsData = computed(() => {
    const data = {
      title: 'Payment Details',
      links: [
        {
          name: 'Home',
          path: '/operator/users'
        },
        {
          name: 'Payment',
          path: '/operator/finance/payments'
        },
        {
          name: 'Payment Details',
          path: `/operator/finance/payments/seller-detail/${params.value.id}`
        },
      ]
    }
    return data;
  })

  const setShowPaymentDetailModal = (status, billingIdData = '') => {
    billingId.value = billingIdData;
    showPaymentDetailModal.value = status;
  }


  const setShowHistoryModal = status => {
    showHistoryModal.value = status;
  }
// 过滤对象中值为null、空字符串和undefined的字段
const filterEmptyFields = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  
  const filteredObj = {};
  for (const [key, value] of Object.entries(obj)) {
    // 只保留非null、非空字符串和非undefined的值
    if (value !== null && value !== '' && value !== undefined) {
      filteredObj[key] = value;
    }
  }
  return filteredObj;
};
  const setBillingId = id => {
    billingId.value = id;
  }
  const toDeclinedCallback = async (id) => {
    const res = await financeApi.financePublisherBillingsDetailsDecline({billingId: id});
    if(res.success){
    getFinancePublisherDetailInfo();
    getFinancePublisherBillingsDetailsList();
    }else{
      message.error(res.error);
    }

  }
  const toUnDoDeclinedCallback = async (id) => {
    const res = await financeApi.financePublisherBillingsDetailsUndoDecline({billingId: id});
    if(res.success){
    getFinancePublisherDetailInfo();
    getFinancePublisherBillingsDetailsList();
    }else{
      message.error(res.error);
    }
  }
  const exportData=()=>{
      let time = moment().format("YYYY-MM-DD");
      const data=filterEmptyFields(params.value);
    financeApi.financePublisherBillingsDetailsExport({
      qs: data,
      fileName: `publisher-billings-details-${time}.csv`,
      platform: 'operator',
    })
  }
  const setShowPaymentModal = (status, reload) => {
    showPaymentModal.value = status;
    if (!status) {
      billingId.value = '';
    }
    if (reload) {
      getFinancePublisherDetailInfo();
      getFinancePublisherBillingsDetailsList();
    }
  }

  const setParams = data => {
    if (data) {
      params.value = data;
    } else {
      params.value.sellerPayStatus = null;
      params.value.detailStatus = null;
      params.value.publisherId = null;
      params.value.billingId = null;
      params.value.page = 1;
      getFinancePublisherDetailInfo();
      getFinancePublisherBillingsDetailsList();
    }
  }

  const setShowConfirmModal = status => {
    showConfirmModal.value = status;
  }

  const onChangeStatus = async () => {
    spinning.value = true;
    const res = await financeApi.financePublisherBillingsConfirm({id: params.value.id});
    if (res === null) {
      message.success('Success');
      showConfirmModal.value = false;
      getFinancePublisherDetailInfo();
      getFinancePublisherBillingsDetailsList();
    }
    spinning.value = false;
  }

  const searchPublisher = async keyword => {
    let res, paramsData = { keyword, size: 100, page: 1, reviewStatus: 'Approved', };
    res = await publisherAdminApi.getPublisherList(paramsData);
    if (res && res.data) {
      sellerOptions.value = res.data.map(item => {
        item.value = item.id;
        item.label = item.creatorName;
        return item;
      })
    }
  }

  const onChangePublisher = id => {
    params.value.publisherId = id;
  }

  const getFinancePublisherBillingsDetailsList = async () => {
    spinning.value = true;
    const res = await financeApi.getFinancePublisherBillingsDetailsList(params.value);
    const { data } = res;
    if (res && res.data) {
      listTotal.value = res.total;
      list.value = res.data;
    }
    spinning.value = false;
  }

  const getFinancePublisherDetailInfo = async () => {
    spinning.value = true;
    const res = await financeApi.getFinancePublisherDetailInfo(params.value);
    if (res) {
      detailData.value = res;
    }
    spinning.value = false;
  }

  onBeforeMount(() => {
    const { id } = route.params;
    if (id) {
      params.value.id = id;
    }
  })

  onMounted(() => {
    getFinancePublisherDetailInfo();
    getFinancePublisherBillingsDetailsList();
  })

</script>
<style lang="less" scoped>
.seller-detail {
  padding: 0 16px 16px;
  .content-wrap {
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);
    padding: 16px;
  }
  .info-wrap {
    .head {
      height: 28px;
      color: var(--dark-1);
      font-weight: 600;
      font-size: 20px;
      letter-spacing: 0.5px;
      line-height: 28px;
      padding-bottom: 8px;
    }
    .info {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .left {
        display: flex;
        flex-direction: column;
        display: flex;
        > div {
          display: flex;
        }
        .text {
          margin-right: 30px;
          margin-top: 10px;
          > span:last-child {
            color: var(--dark-1);
            font-weight: 600;
            font-size: 14px;
            letter-spacing: 0.3px;
            margin-left:4px;
          }
        }
      }
    }
  }
  .details {
    margin-top: 20px;
    .head {
      display: flex;
      justify-content: space-between;
      > span {
        height: 28px;
        color: var(--dark-1);
        font-weight: 600;
        font-size: 20px;
        letter-spacing: 0.5px;
        line-height: 28px;
        padding-bottom: 8px;
      }
    }
    .operation {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        .item {
          margin-right: 20px;
          > span {
            color: var(--dark-2);
            font-weight: 500;
            font-size: 13px;
            letter-spacing: 0.3px;
            line-height: 18px;
            margin-right: 8px;
          }
        }
        
      }
      .right {
        min-width: 240px;
        display: flex;
        gap: 12px;
        margin-right: 16px;
        button {
         
          align-self: flex-end;
        }
      }
    }
  }
  .table {
    margin-top: 20px;
  }
}


</style>